import { eventSchemaId, libraryWideEventSchemaId } from '../fixture-ids';

export const eventSchemaEntries = {
  EVENT_SCHEMA_CREATED: {
    entity: 'eventSchema',
    identity: 'record',
    idKeys: ['eventSchemaId'],
    renderMode: 'diff',
    createsRecord: true,
    foreignDisplayKeys: ['name'],
  },
  EVENT_SCHEMA_UPDATED: {
    entity: 'eventSchema',
    identity: 'record',
    idKeys: ['eventSchemaId'],
    renderMode: 'diff',
    createsRecord: false,
    foreignDisplayKeys: ['name'],
  },
  EVENT_SCHEMA_DELETED: {
    entity: 'eventSchema',
    identity: 'record',
    idKeys: ['eventSchemaId'],
    renderMode: 'diff',
    createsRecord: false,
    foreignDisplayKeys: ['name'],
  },
};

export const eventSchemaFixtures = {
  EVENT_SCHEMA_CREATED: {
    action: 'EVENT_SCHEMA_CREATED',
    debugData: {
      eventSchemaId,
      name: 'checkout_completed',
      description: 'Fires when a checkout completes successfully',
    },
  },
  EVENT_SCHEMA_UPDATED: {
    action: 'EVENT_SCHEMA_UPDATED',
    debugData: {
      eventSchemaId,
      name: 'checkout_completed',
      description: 'Fires when a checkout completes successfully (updated)',
    },
  },
  EVENT_SCHEMA_DELETED: {
    action: 'EVENT_SCHEMA_DELETED',
    debugData: {
      eventSchemaId,
      name: 'checkout_completed',
      description: 'Fires when a checkout completes successfully (updated)',
    },
  },
  // event_name_id IS NULL case: the writer's own COALESCE fallback ('All Events' / ''), a
  // legitimate library-wide event schema, not a "lookup missed" case -- see Notes.
  EVENT_SCHEMA_CREATED_NO_EVENT_NAME: {
    action: 'EVENT_SCHEMA_CREATED',
    debugData: { eventSchemaId: libraryWideEventSchemaId, name: 'All Events', description: '' },
  },
};
